import React, { FC } from 'react'

import { addProjectCoordinatorToProject } from 'state/async_actions'
import { AddUserDropdown } from 'components/AddUserDropdown'
import { AutocompleteableItem, User } from 'types'
import { useProjectCoordinators } from 'hooks/useProjectCoordinators'
import { useAppContext } from 'state/context'

interface AddProjectCoordinatorDropdownProps {
  excludedProjectCoordinators: User[]
  projectId: number
  templateDocumentId:number
}

export const AddProjectCoordinatorDropdown: FC<AddProjectCoordinatorDropdownProps> = ({
  excludedProjectCoordinators = [],
  projectId,
  templateDocumentId
}) => {
  const [, dispatch] = useAppContext()

  const addProjectCoordinator: (item: AutocompleteableItem) => void = ({
    payload,
  }) => addProjectCoordinatorToProject(dispatch, projectId, payload)

  const projectCoordinators: any = useProjectCoordinators()

  return (
    <AddUserDropdown
      addUser={addProjectCoordinator}
      excludedMembers={excludedProjectCoordinators}
      users={projectCoordinators || []}
      userType="Project Coordinator"
      projectId={projectId}
      templateDocumentId={templateDocumentId}
    />
  )
}